import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiNetlify,
  SiOpenai,
  SiGithub,
  SiLinux,
  SiTelegram,
} from "react-icons/si";
import { FaWindows, FaDiscord } from "react-icons/fa";
import { TbBrandVscode } from "react-icons/tb";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={2} md={2} className="tech-icons" title="Windows">
        <FaWindows />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Linux">
        <SiLinux />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="VS Code">
        <TbBrandVscode />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Netlify">
        <SiNetlify />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="OpenAI">
        <SiOpenai />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="GitHub">
        <SiGithub />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Telegram">
        <SiTelegram />
      </Col>
      <Col xs={2} md={2} className="tech-icons" title="Discord">
        <FaDiscord />
      </Col>
    </Row>
  );
}

export default Toolstack;
